export const DIAGRAM_TEMPLATES = [
  {
    type: "flowchart",
    name: "Flowchart",
    description: "Process flows and decision trees",
    template: `graph TD
    A[Start] --> B[Process]
    B --> C{Decision?}
    C -->|Yes| D[Action A]
    C -->|No| E[Action B]
    D --> F[End]
    E --> F`
  },
  {
    type: "sequence",
    name: "Sequence Diagram",
    description: "Interactions between actors over time",
    template: `sequenceDiagram
    participant A as Actor A
    participant B as Actor B
    A->>B: Message 1
    B-->>A: Response 1
    A->>B: Message 2
    B-->>A: Response 2`
  },
  {
    type: "class",
    name: "Class Diagram",
    description: "Object-oriented system structure",
    template: `classDiagram
    class ClassName {
        +attribute1: Type
        +attribute2: Type
        +method1()
        +method2()
    }
    class AnotherClass {
        +attribute: Type
        +method()
    }
    ClassName --> AnotherClass : relationship`
  },
  {
    type: "state",
    name: "State Diagram",
    description: "State transitions and behavior",
    template: `stateDiagram-v2
    [*] --> State1
    State1 --> State2 : event1
    State2 --> State3 : event2
    State3 --> [*] : end`
  },
  {
    type: "er",
    name: "Entity Relationship",
    description: "Database relationships and structure",
    template: `erDiagram
    ENTITY1 ||--o{ ENTITY2 : relationship
    ENTITY1 {
        int id PK
        string attribute1
        string attribute2
    }
    ENTITY2 {
        int id PK
        int entity1_id FK
        string attribute
    }`
  },
  {
    type: "gantt",
    name: "Gantt Chart",
    description: "Project timelines and schedules",
    template: `gantt
    title Project Timeline
    dateFormat YYYY-MM-DD
    section Phase 1
    Task 1 :task1, 2024-01-01, 10d
    Task 2 :task2, after task1, 5d
    section Phase 2  
    Task 3 :task3, 2024-01-15, 7d`
  },
  {
    type: "pie",
    name: "Pie Chart",
    description: "Data distribution visualization",
    template: `pie title Data Distribution
    "Category A" : 42
    "Category B" : 30  
    "Category C" : 28`
  },
  {
    type: "journey",
    name: "User Journey",
    description: "User experience mapping",
    template: `journey
    title User Journey
    section Phase 1
      Step 1: 5: User
      Step 2: 4: User
    section Phase 2
      Step 3: 3: User
      Step 4: 5: User`
  }
];
